import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect, useMemo, useRef } from "react";
import { Helpers } from "@customink/signalmizely-web";
import { SignalmizelyContext } from "./context.js";
export function SignalmizelyProvider({ config, children }) {
    const [helpers, setHelpers] = useState(null);
    const helpersRef = useRef(null);
    useEffect(() => {
        const initializeHelpers = async () => {
            try {
                // Clean up previous helpers
                if (helpersRef.current) {
                    await helpersRef.current.close();
                }
                const helpersInstance = new Helpers(config);
                helpersRef.current = helpersInstance;
                setHelpers(helpersInstance);
            }
            catch (error) {
                console.error("Failed to initialize Signalmizely Helpers:", error);
                setHelpers(null);
            }
        };
        initializeHelpers();
        return () => {
            if (helpersRef.current) {
                helpersRef.current.close().catch((error) => {
                    console.error("Error closing Signalmizely Helpers:", error);
                });
                helpersRef.current = null;
            }
        };
    }, [JSON.stringify(config)]); // Use serialized config as dependency to avoid object recreation issues
    const contextValue = useMemo(() => ({
        helpers,
    }), [helpers]);
    return (_jsx(SignalmizelyContext.Provider, { value: contextValue, children: children }));
}
